import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: './parts-message.component.html',
    standalone: false
})
export class PartsMessageComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
